import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-editor-content-cell',
  templateUrl: './editor-content-cell.component.html',
  styleUrls: ['./editor-content-cell.component.scss']
})
export class EditorContentCellComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
